// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5dde0a62","333":"e07b7769","522":"28efb42e","540":"b68c95f9","672":"ede6f704","798":"947a39be","828":"071b55a2"}[chunkId] + ".chunk.js";
};